import React, { useEffect, useState } from "react";

import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import InputTextarea from "../../../components/InputTextarea";

import api from "../../../services/api";
import { renderError } from "../../../helpers/errors";

/**
 * Cancelamento da nota autorizada (BDM-887).
 *
 * Compartilhado pela lista e pela aba do pedido — o ciclo de vida da nota
 * precisa se comportar igual nos dois lugares. Quem decide se ainda dá tempo
 * de cancelar é a SEFAZ: a tela não antecipa prazo.
 */
export const ModalCancelDocument = ({ document, close, onDone }) => {
    const [reason, setReason] = useState('');
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        if (document) setReason('');
    }, [document]);

    const cancel = () => {
        setProcessing(true);

        api.patch(`/fiscal-document/${document.id}/cancel`, { reason }).then(() => {
            onDone('Cancelamento solicitado. A SEFAZ responde em instantes.');
            close();
        }).catch(renderError).then(() => setProcessing(false));
    };

    return (
        <Modal
            show={document !== null}
            close={close}
            title={`Cancelar nota fiscal`}
            footer={
                <Button
                    type={`primary`}
                    size={`small`}
                    text={`Confirmar cancelamento`}
                    action={cancel}
                    loading={processing}
                    disabled={reason.trim().length < 15}
                />
            }
        >
            <div className="section">
                <p>
                    O cancelamento é enviado à SEFAZ e não pode ser desfeito.
                    {document?.number ? ` Nota nº ${document.number}.` : ''}
                </p>

                <InputTextarea
                    label={`Por que está cancelando?`}
                    value={reason}
                    change={setReason}
                    rows={3}
                />
                <p className={`fiscal-hint`}>
                    A SEFAZ exige no mínimo 15 caracteres. {reason.trim().length}/15
                </p>
            </div>
        </Modal>
    );
};

export default ModalCancelDocument;
